/**
 * ExcelWidgetAgentService
 *
 * Sends one plain-English instruction plus the excel widget's current cells to
 * the excel widget agent, and gets back only the cells that should change,
 * keyed by A1-style address. An empty string means "clear that cell".
 */

import { requestJson } from './api/client';

export interface ExcelWidgetSheet {
  rows: number;
  cols: number;
  cells: Record<string, string>;
}

export interface ExcelWidgetEditRequest {
  instruction: string;
  sheet: ExcelWidgetSheet;
}

export interface ExcelWidgetEdit {
  /** The grid the sheet must have for the patch to fit. Only ever grows. */
  rows: number;
  cols: number;
  cells: Record<string, string>;
}

export const editExcelWidget = async (
  instruction: string,
  sheet: ExcelWidgetSheet,
  signal?: AbortSignal,
): Promise<ExcelWidgetEdit> => {
  const trimmed = instruction.trim();
  if (!trimmed) {
    throw new Error('Instruction must be a non-empty string.');
  }

  return requestJson<ExcelWidgetEdit, ExcelWidgetEditRequest>(
    'POST',
    '/api/excel-widget/edit',
    { instruction: trimmed, sheet },
    signal,
  );
};
